enum ElectronActionTypes {
    SET_FULL_SCREEN = "electron/setFullScreen",
    SET_WINDOW_MAXIMIZED = "electron/setWindowMaximized",
}

export default ElectronActionTypes;
